import React from 'react'
import { Box, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles({
  container: {
    position: 'sticky',
    top: 0,
    backgroundColor: '#ffffff',
    padding: '12px 0 12px',
    zIndex: 99,
    marginBottom: 8
  },
  pageTitle: {
    fontWeight: 700,
    fontSize: '20px',
    color: '#0f172a'
  }
})

const ViewHeader = ({ title, children, rightComponent }) => {
  const classes = useStyles()
  return (
    <Box className={classes.container} style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant="h4" className={classes.pageTitle}>
          {title}
        </Typography>
      </div>
      <span style={{ flex: 1 }} />
      {rightComponent ? rightComponent : null}
      {children}
    </Box>
  )
}

export default ViewHeader
